import { UserInfo } from 'src/app/interfaces';
import { MessagingChannelBasic } from 'src/app/swagger-api';

export interface ChatEngineHandle {
  isValid(): boolean;
}

export interface ChatConversation {
  relatedEntityId: string;
  effectiveTitle: string;
  originalTitle: string | null;
  participatingUsers: UserInfo[];
  channel: MessagingChannelBasic;
  channelType: ChatChannelType;
  lastMessage: ChatMessage | null;
  imageUrl?: string;
}

export interface ChatMessage {
  entity_id: string;
  text: string;
  sender: UserInfo;
  dateUpdated: string;
  dateCreated: string;
  isRead: boolean;
  channel_id: string;
}

export enum ChatChannelType {
  CONVERSATION = 'conversation',
  NOTIFICATION = 'notification',
}

export interface ChatTypingIndicator {
  typingName: string;
  isTyping: boolean;
}

export interface ChatTraceData {
  channelUniqueName?: string;
  participantId?: string;
  userId?: string;
  messageId?: string;
}

export interface ChatParticipantInfo {
  conversation: ChatConversation;
  participant: UserInfo;
}
